export default class Newsfeed {
  constructor(el, args) {
    this.el = el;
    this.feedbase = window.location.origin;
    this.feeduri = '/news/homepage/?s=';
    this.link = '.entry-title a';
    this.title = '.entry-title';
    this.content = '.entry-content';
    this.datewrapper = '.datetime';
    this.datestartclass = '.dtstart';
    this.dateendclass = '.dtend';
    this.showsummary = false;
    this.showdates = true;
    Object.assign(this, args);
    this.getdata();
  }

  async getdata() {
    await fetch(this.feedbase + this.feeduri)
      .then((res) => {
        return res.text();
      })
      .then((data) => {
        this.replacefeed(data);
      });
  }

  replacefeed(html) {
    this.el.insertAdjacentHTML('afterend', html);
    if (this.showdates) {
      [...this.el.parentNode.querySelectorAll(`${this.datewrapper}`)].forEach(
        (el) => {
          let startdate = null,
            enddate = null;
          el.querySelector(this.datestartclass)
            ? (startdate = el.querySelector(this.datestartclass).textContent)
            : false;
          el.querySelector(this.dateendclass)
            ? (enddate = el.querySelector(this.dateendclass).textContent)
            : false;
          let dates = '';
          startdate && enddate ? (dates = `${startdate} ${enddate}`) : false;
          startdate && !enddate ? (dates = startdate) : false;
          !startdate && enddate ? (dates = enddate) : false;
          el.insertAdjacentHTML('beforebegin', dates);
          el.parentNode.removeChild(el);
        }
      );
    }
    !this.showsummary
      ? [...this.el.parentNode.querySelectorAll(this.content)].forEach((el) => {
          el.parentNode.removeChild(el);
        })
      : false;
    this.el.parentNode.removeChild(this.el);
  }
}
